import { z } from 'zod';

export const requisitionItemSchema = z.object({
  lineId: z.string(),
  itemId: z.string(),
  itemName: z.string(),
  sku: z.string(),
  requestedQuantity: z.number(),
  approvedQuantity: z.number().optional(),
  fulfilledQuantity: z.number().optional(),
  unit: z.string(),
  notes: z.string().optional(),
});

export type RequisitionItem = z.infer<typeof requisitionItemSchema>;

export const requisitionSchema = z.object({
  requisitionId: z.string(),
  siteId: z.string(),
  venueId: z.string(),
  venueName: z.string(),
  status: z.enum(['draft', 'pending', 'approved', 'rejected', 'fulfilled', 'partial']),
  requestedBy: z.string(),
  requestedByName: z.string(),
  requestedAt: z.string(),
  neededBy: z.string(),
  approvedBy: z.string().optional(),
  approvedByName: z.string().optional(),
  approvedAt: z.string().optional(),
  items: z.array(requisitionItemSchema),
  totalItems: z.number(),
  notes: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type Requisition = z.infer<typeof requisitionSchema>;

export const requisitionsResponseSchema = z.object({
  data: z.array(requisitionSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number() 
  }),
  meta: z.object({ siteId: z.string() }),
});

export type RequisitionsResponse = z.infer<typeof requisitionsResponseSchema>;

export type RequisitionStatus = Requisition['status'];

export const STATUS_LABELS: Record<RequisitionStatus, string> = {
  draft: 'Draft',
  pending: 'Pending Approval',
  approved: 'Approved',
  rejected: 'Rejected',
  fulfilled: 'Fulfilled',
  partial: 'Partially Fulfilled',
};

export const STATUS_COLORS: Record<RequisitionStatus, string> = {
  draft: 'bg-gray-100 text-gray-800',
  pending: 'bg-amber-100 text-amber-800',
  approved: 'bg-blue-100 text-blue-800',
  rejected: 'bg-red-100 text-red-800',
  fulfilled: 'bg-green-100 text-green-800',
  partial: 'bg-purple-100 text-purple-800',
};
